const DEBOUNCE_TIMEOUT = 200;
const LOG_PREFIX = '[GET - Query Suggestions]';

const constants = {
  DEBOUNCE_TIMEOUT,
  LOG_PREFIX,
};

export default constants;
